import React, { useContext, useEffect } from "react";
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import { OverviewContext } from "../overview/context/OverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";
import Box from "@amzn/meridian/box";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import Icon from "@amzn/meridian/icon";
import { isStringEmpty } from "../util/Util";
import { LINEHAUL_STATUS } from "../overview/utils/PPAConstants";

const LinehaulsAtRiskView = (props) => {
  const { viewModel, dispatch } = useContext(OverviewContext);
  const linehaulData = viewModel.linehaul[props.linehaul.processName].value;

  const getNodeLinehaulData = () => {
    dispatch({
      type: "LOAD_NODE_LINEHAUL_DATA",
      data: {
        dispatcher: dispatch,
      },
    });
  };

  useEffect(() => {
    getNodeLinehaulData();
    const interval = setInterval(() => {
      if (!document.hidden) {
        getNodeLinehaulData();
      }
    }, props.linehaul.refreshRate);
    return () => clearInterval(interval);
  }, []);

  const isLineHaulLate = (linehaulTime) => {
    if (
      linehaulTime == null ||
      isStringEmpty(linehaulTime.actualTime) ||
      isStringEmpty(linehaulTime.plannedTime)
    ) {
      return false;
    }
    const actual = new Date(linehaulTime.actualTime);
    const planned = new Date(linehaulTime.plannedTime);
    return actual > planned;
  };

  const getLateLinehauls = (linehaulData) => {
    if (linehaulData == null) {
      return 0;
    }

    const lateLinehauls = linehaulData.filter((linehaul) =>
      isLineHaulLate(linehaul.lineHaulTime),
    );
    return lateLinehauls.length;
  };

  const getLineHaulStatus = (linehaulData, status) => {
    if (linehaulData == null) {
      return 0;
    }
    const linhaulsWithStatus = linehaulData.filter(
      (linehaul) => linehaul.lineHaulStatus === status,
    );
    return linhaulsWithStatus.length;
  };

  const isAlert = (data) => {
    if (!isNaN(parseInt(data, 10))) {
      return parseInt(data, 10) > 0;
    }
    return false;
  };

  const lateLinehauls = getLateLinehauls(linehaulData);
  return (
    <Box type="outline" spacingInset="400">
      <div>
        <div className="overview-linehaul">
          <Heading level={2} type="h300" alignment="left">
            <FormattedMessage
              id={viewModel.linehaul[props.linehaul.processName].title}
              defaultMessage={
                viewModel.linehaul[props.linehaul.processName].defaultMessage
              }
            />
            <Tooltip
              position="right"
              title={props.intl.formatMessage({
                id: viewModel.linehaul[props.linehaul.processName].tooltip,
                defaultMessage:
                  viewModel.linehaul[props.linehaul.processName].tooltipMessage,
              })}
            >
              <Icon className={"custom-tool-tip"} tokens={infoKnockoutTokens} />
            </Tooltip>
          </Heading>
        </div>
        <Row width="100%" widths={["grid-6", "grid-6"]}>
          <div>
            <Text type="b100">
              <FormattedMessage id="linehaul.late" defaultMessage="Late" />
            </Text>
            {isAlert(lateLinehauls) ? (
              <Text type="d50" className="alert">
                {lateLinehauls}
              </Text>
            ) : (
              <Text type="d50">{lateLinehauls}</Text>
            )}
          </div>
          <div>
            <Text type="b100">
              <FormattedMessage
                id="linehaul.status"
                defaultMessage="Arrived/In transit/Pending depart"
              />
            </Text>
            <Text type="d50">
              {`${getLineHaulStatus(linehaulData, LINEHAUL_STATUS.ARRIVED)}/${getLineHaulStatus(linehaulData, LINEHAUL_STATUS.IN_TRANSIT)}/${getLineHaulStatus(linehaulData, LINEHAUL_STATUS.PENDING_DEPART)}`}
            </Text>
          </div>
        </Row>
      </div>
    </Box>
  );
};

export default injectIntl(LinehaulsAtRiskView);



// WEBPACK FOOTER //
// ./src/components/linehaul/LinehaulsAtRiskView.js